import React, { useEffect, useRef, useContext } from "react";
import { graphql } from "gatsby";
import Scrollspy from "react-scrollspy";
import { WrapperContext } from "../components/Layout";
import Seo from "../components/seo";
import Product from "../components/shop/Product";
import Aside from "../components/Aside";

export const query = graphql`
  query Catalog {
    sanityCatalog {
      seo {
        metaTitle
        metaDescription
      }
      title
      _rawProducts(resolveReferences: { maxDepth: 10 })
    }
  }
`;

const Catalog = ({ data }) => {
  const { location } = useContext(WrapperContext);
  // const location = "http://localhost:8000/e-shop";

  const { seo, _rawProducts } = data.sanityCatalog;

  const getAsideNav = () =>
    _rawProducts.map((el) => {
      return { id: el.slug.current, title: el.title };
    });

  return (
    <div className='catalog'>
      {seo && (
        <Seo
          pageTitle={seo.metaTitle}
          pageDescription={seo.metaDescription}
          // pageImage={image_featured.url}
          template={`template-catalog`}
          page={false}
        />
      )}
      <Aside input={getAsideNav()} />

      {_rawProducts.map((product, i) => (
        <Product key={i} input={product} url={location.href} />
      ))}
    </div>
  );
};

export default Catalog;
